export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重复操作"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作历史"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["账户列表"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未知错误"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["令牌列表"])}
}